import React from "react";
import { Field } from "react-final-form";
import { TextFieldAdapter } from "@soqs/common";

const MalpracticeDescr = (props) => {
  let { required, name, label, rows, fieldlength } = props;

  if (required === undefined) {
    required = false;
  }
  if (name === undefined) {
    name = "field";
  }
  if (label === undefined) {
    label = "Field";
  }
  if (fieldlength === undefined) {
    fieldlength = 3000;
  }
  if (rows === undefined) {
    rows = 2;
  }

  const isValid = (x) => {
    const re = /^[ @/\n/&-.0-:A-Za-z]{100,3000}$/;
    return (x || !required) &&
      (re.test(x) || (!required && (x === undefined || x?.length === 0)))
      ? undefined
      : "Please provide a description of the incident by capturing a min of <100> characters";
  };

  return (
    <Field
      name={name}
      validate={isValid}
      required={required}
      label={label}
      autoComplete=""
      component={TextFieldAdapter}
      subscription={{ touched: true, value: true, error: true }}
      fullWidth
      inputProps={{ maxLength: fieldlength }}
      multiline={true}
      rows={rows}
    />
  );
};

export default MalpracticeDescr;
